import React from "react";

import { ShareMobileTestDetails } from "./ShareMobileTestDetails";

export const ShareMobileView = () => {
  return <ShareMobileTestDetails />;
};
